// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__oY2zd","card":"Cards_card__EMYXE","cardIcon":"Cards_cardIcon__0Awej","text":"Cards_text__RqXzi"};